import { CheckCircleRounded, HighlightOffRounded } from '@mui/icons-material'
import { useVehicle } from 'contexts'
import React from 'react'
import { Link } from 'react-router-dom'
import { useGetFilesUrls } from 'utils/hooks/queries'
import { getDocumentsFileStorageIds, resolveDocumentsUrls, ResolvedDocument } from 'utils/helpers'

const DOCUMENT_LABELS = {
  GrayCard: 'Carte grise',
  TechnicalCheck: 'Contrôle technique',
  MaintenanceLogBook: "Carnet d'entretien",
  ExpertAssessment: 'Bilan expert',
  ExplodedViewer: 'Éclaté carrosserie',
  Soh: 'Test batterie',
} as const

const DISPLAYED_DOCTYPES = new Set(Object.keys(DOCUMENT_LABELS))

const VehicleSheetDocuments = () => {
  const vehicle = useVehicle()
  const vehicleDocuments = React.useMemo(() => vehicle.documents ?? [], [vehicle.documents])

  const relevantDocuments = React.useMemo(
    () => vehicleDocuments.filter((doc) => doc.doctype && DISPLAYED_DOCTYPES.has(doc.doctype)),
    [vehicleDocuments],
  )

  const documentIds = getDocumentsFileStorageIds(relevantDocuments)
  const { idsAndUrls } = useGetFilesUrls(documentIds)

  const resolvedDocuments = React.useMemo(
    () => resolveDocumentsUrls(relevantDocuments, idsAndUrls),
    [relevantDocuments, idsAndUrls],
  )

  const documentsByDoctype = React.useMemo(() => {
    const map = new Map<string, ResolvedDocument>()
    resolvedDocuments.forEach((entry) => {
      if (entry.document.doctype) {
        map.set(entry.document.doctype, entry)
      }
    })
    return map
  }, [resolvedDocuments])

  return (
    <ul className="vehicle-sheet__document-list">
      {Object.entries(DOCUMENT_LABELS).map(([key, label]) => {
        const document = documentsByDoctype.get(key)
        const url = document?.url

        return (
          <li
            key={key}
            className="vehicle-sheet__document-item"
          >
            <span className="vehicle-sheet__document-label">{label}</span>
            {url ? (
              <Link
                to={url}
                target="_blank"
                rel="noopener noreferrer"
                title={`Voir : ${label}`}
                className="vehicle-sheet__document-status vehicle-sheet__document-status--available"
              >
                <CheckCircleRounded aria-hidden="true" />
                <span>Voir</span>
              </Link>
            ) : (
              <span className="vehicle-sheet__document-status vehicle-sheet__document-status--missing">
                <HighlightOffRounded aria-hidden="true" />
                <span>Absent</span>
              </span>
            )}
          </li>
        )
      })}
    </ul>
  )
}

export default VehicleSheetDocuments
